// Money is always integer pence (GBP only in v1).

export type PenceAmount = number;

export function formatPence(pence: PenceAmount): string {
  const sign = pence < 0 ? '-' : '';
  const abs = Math.abs(pence);
  return `${sign}£${Math.floor(abs / 100).toLocaleString('en-GB')}.${String(abs % 100).padStart(2, '0')}`;
}

/** "12", "12.5", "£12.50" → 1250. Returns null for anything unparseable. */
export function parsePounds(input: string): PenceAmount | null {
  const cleaned = input.replace(/[£,\s]/g, '');
  if (!/^-?\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const [whole, frac = ''] = cleaned.replace('-', '').split('.');
  const pence = Number(whole) * 100 + Number(frac.padEnd(2, '0'));
  return cleaned.startsWith('-') ? -pence : pence;
}

export function sumPence(values: PenceAmount[]): PenceAmount {
  return values.reduce((a, b) => a + b, 0);
}
